const zh_CN = {
  placeholderText: "请输入",
  closeContentText: "确定结束当前对话?",
  cancelText: "取消",
  okText: "确定",
  loadingAnswerQuestions: "正在回答上一个问题，请稍后提交",
  networkAnomalyText: "网络异常，请稍后重试",
  messageTooShort: "问题至少需要2个文字",
  messageTooLong: "问题不能超过200个文字",
  messageCannotBeEmpty: "问题不能为空",
  systemErrorText: "系统出错",
};
export default zh_CN;
